<nav aria-label="Paginapad">
	<ol class="crumbs">
		<li #homeLi>
			<a routerLink="/start">
				<app-icon name="startpagina" size="medium" color="typography-1" hoverColor="primary-1"></app-icon>
				<span class="sr-only">Startpagina</span>
			</a>
		</li>
		@for (crumb of visibleCrumbs(); track $index) {
			<li>
				<app-icon name="chevron-right" size="smallest" color="typography-5"></app-icon>
				@if (crumb.truncated) {
					@if (crumb.clickable) {
						<a [routerLink]="crumb.url" [queryParams]="crumb.queryParams" [appTooltip]="crumb.label">
							<span aria-hidden="true">…</span>
							<span class="sr-only">{{ crumb.label }}</span>
						</a>
					} @else {
						<span [appTooltip]="crumb.label">
							<span aria-hidden="true">…</span>
							<span class="sr-only">{{ crumb.label }}</span>
						</span>
					}
				} @else if (crumb.clickable) {
					<a [routerLink]="crumb.url" [queryParams]="crumb.queryParams">{{ crumb.label }}</a>
				} @else {
					<span [attr.aria-current]="crumb.current ? 'page' : null">{{ crumb.label }}</span>
				}
			</li>
		}
	</ol>
	<ol class="meten" aria-hidden="true">
		<li #meetEllipsis>
			<app-icon name="chevron-right" size="smallest" color="typography-5"></app-icon>
			<span>…</span>
		</li>
		@for (crumb of crumbs(); track $index) {
			<li #meetCrumb>
				<app-icon name="chevron-right" size="smallest" color="typography-5"></app-icon>
				<span>{{ crumb.label }}</span>
			</li>
		}
	</ol>
</nav>
